module.exports = __webpack_public_path__ + "static/media/C8.9061257a.jpg";